<template>
  <div>
    <div class="gSwiperBox-banner">
      <swiper :options="swiperOption" ref="mySwiper-banner">
        <swiper-slide v-for="(item, index) in list" :key="index">
          <a :href="item.url" v-if="item.link" target="_blank">
            <img v-if="item.path" :src="item.path" />
          </a>
          <div v-else>
            <img v-if="item.path" :src="item.path" />
          </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <!-- <div class="swiper-button-prev">
        <i class="icon iconfont icon-xiangshang"></i>
      </div>
      <div class="swiper-button-next">
        <i class="icon iconfont icon-xiangshang"></i>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "gSwiper",
  data() {
    return {
      list: [],
    };
  },
  computed: {
    swiperOption() {
      let that = this;
      let opt = {
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // grabCursor: true,
        // paginationClickable: true,
        // onSlideClick: function(swiper) {
        //   const s = swiper.clickedSlide.attributes["data-href"];
        //   const Datafrom = swiper.clickedSlide.attributes["data-Datafrom"];
        //   if (Datafrom && Datafrom.nodeValue) {
        //     that.setSourse(Datafrom.nodeValue);
        //     that.setShowHostModal(true);
        //   }
        //   if (s && /(http|https):\/\/([\w.]+\/?)\S*/.test(s.nodeValue)) {
        //     window.open(s.nodeValue);
        //   }
        // }
      };
      return opt;
    },
    swiper() {
      return this.$refs.mySwiper - banner.swiper;
    },
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    ...mapActions({
      getCommonAd: "hostCommonModule/getCommonAd",
    }),
    async getHomeBanner() {
      let res = await this.getCommonAd({
        id: "BF3E663A-2445-4EFC-87E6-3EB3E829BAFC",
        typeid: 0,
      });
      let arr = [];
      if (res && res.length) {
        res.map((c) => {
          if (c.typeId === 0) {
            arr.push(c);
          }
        });
      }
      this.list = arr;
      // console.log("banner：",res)
    },
  },
  created() {
    this.getHomeBanner();
  },
};
</script>

<style lang="scss">
.swiper-slide {
  img {
    width: 100%;
    // max-height: 400px;
    // height: 384px;
  }
}

.gSwiperBox-banner {
  position: relative; 

  &:hover {
    .swiper-button-prev {
      visibility: visible;
    }

    .swiper-button-next {
      visibility: visible;
    }
  }

  h1 {
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99;
    font-size: 30px;
    color: #fff;
    top: 30%;
  }

  .banner-btn {
    display: block;
    width: 200px;
    height: 48px;
    background-color: rgba(0, 161, 233, 1);
    text-align: center;
    position: absolute;
    z-index: 99;
    top: 60%;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      background-color: #006fb4;
    }
  }

  .swiper-container {
    font-size: 0;
  }

  .swiper-pagination {
    font-size: 0;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    bottom: 22px;

    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border-radius: 0;
      background-color: #dddddd;
      opacity: 1;
      border-radius: 50%;
    }

    .swiper-pagination-bullet-active {
      background-color: rgba(0, 161, 233, 1);
      opacity: 1;
    }
  }

  .swiper-button-prev {
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid rgba(0, 161, 233, 1);
    border-radius: 50%;
    font-size: 20px;
    color: rgba(0, 161, 233, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    left: 30px;
    visibility: hidden;

    i {
      transform: rotate(-90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }

  .swiper-button-next {
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid rgba(0, 161, 233, 1);
    border-radius: 50%;
    font-size: 20px;
    color: rgba(0, 161, 233, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    right: 30px;
    visibility: hidden;

    i {
      transform: rotate(90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }
}
</style>
